import { render } from "./CompaniesHeader.vue?vue&type=template&id=2469e7b1"
import script from "./CompaniesHeader.vue?vue&type=script&lang=js"
export * from "./CompaniesHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__